import React from 'react';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { IHelpDescription } from '../interfaces/components/IHelpDescription';
import Styled from '../styles/HelpDescription.styled';
import { Popover } from 'antd';

const HelpDescription = ({ msg }: IHelpDescription) => {
    return (
        <Styled.Container style={{ fontSize: '16px', width: 'fit-content' }}>
            <Popover
                content={<div style={{ fontSize: '12px', maxWidth: '200px' }}>{msg}</div>}
                title={<span style={{ fontSize: '13px' }}>Ajuda</span>}
                overlayStyle={{ maxWidth: '220px' }}
            >
                <BsFillQuestionCircleFill style={{ fontSize: '18px' }} />
            </Popover>
        </Styled.Container>
    );
};

export default HelpDescription;
